// Яндекс.Метрика: включается, только если при сборке задан VUE_APP_METRIKA_ID (см. .env.production)
const METRIKA_ID = Number(process.env.VUE_APP_METRIKA_ID) || 0
// VK Ads (пиксель top.mail.ru): включается, только если при сборке задан
// VUE_APP_VK_PIXEL_ID. Нужен не ради рекламы прямо сейчас, а чтобы аудитория
// посетителей копилась ДО первой кампании — иначе ретаргет и lookalike строить не из чего.
const VK_PIXEL_ID = String(process.env.VUE_APP_VK_PIXEL_ID || '')

export function initMetrika(router) {
  if (!METRIKA_ID) return
  /* eslint-disable */
  ;(function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) }
    m[i].l = 1 * new Date()
    k = e.createElement(t); a = e.getElementsByTagName(t)[0]
    k.async = 1; k.src = r; a.parentNode.insertBefore(k, a)
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')
  /* eslint-enable */
  window.ym(METRIKA_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    defer: true, // hit шлём сами на каждый переход SPA-роутера
  })
  // Ручного хита на старте НЕТ намеренно: afterEach срабатывает и на первой
  // навигации, поэтому пара «ручной hit + afterEach» засчитывала первый экран
  // ДВАЖДЫ. С defer:true своих хитов Метрика не шлёт — считаем только мы.
  const origin = window.location.origin
  router.afterEach((to, from) => {
    // ⚠️ На первом заходе referer передавать НЕЛЬЗЯ: from — стартовый маршрут
    // ('/'), и Метрика записала бы переход как внутренний, затерев настоящий
    // источник (поиск, реклама, письмо). Без параметра она берёт document.referrer.
    // Признак первой навигации — пустой from.matched.
    const first = !from || !from.matched || from.matched.length === 0
    const url = origin + to.fullPath
    if (first) {
      window.ym(METRIKA_ID, 'hit', url)
    } else {
      window.ym(METRIKA_ID, 'hit', url, { referer: origin + from.fullPath })
    }
  })
}

// Цели: lead_submit — отправлена форма демо; booking_click — нажата кнопка брони слота;
// booking_confirmed — встреча-разбор забронирована (BookingPicker)
export function reachGoal(name, params) {
  if (METRIKA_ID && window.ym) window.ym(METRIKA_ID, 'reachGoal', name, params)
  // Те же цели дублируем в пиксель VK: без них в рекламном кабинете нельзя ни
  // исключить тех, кто уже оставил заявку, ни оптимизировать кампанию на заявку
  // вместо клика. Обращаемся к window._tmr заново — загрузившийся счётчик
  // подменяет его своим объектом (см. комментарий в initVkPixel).
  if (VK_PIXEL_ID && window._tmr) {
    window._tmr.push({ id: VK_PIXEL_ID, type: 'reachGoal', goal: name, params })
  }
}

export function initVkPixel(router) {
  if (!VK_PIXEL_ID) return
  window._tmr = window._tmr || []
  /* eslint-disable */
  ;(function (d, w, id) {
    if (d.getElementById(id)) return
    var ts = d.createElement('script'); ts.type = 'text/javascript'; ts.async = true; ts.id = id
    ts.src = 'https://top-fwz1.mail.ru/js/code.js'
    var f = function () { var s = d.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ts, s) }
    if (w.opera == '[object Opera]') { d.addEventListener('DOMContentLoaded', f, false) } else { f() }
  })(document, window, 'tmr-code')
  /* eslint-enable */
  // Стартового pageView в загрузчике НЕТ намеренно — по той же причине, что и у
  // Метрики выше: afterEach срабатывает и на первой навигации, и пара
  // «пуш при загрузке + afterEach» посчитала бы первый экран дважды.
  router.afterEach(() => {
    // ⚠️ Обращаться к window._tmr КАЖДЫЙ раз, а не держать ссылку на массив:
    // загрузившийся код счётчика подменяет window._tmr своим объектом, и пуши
    // в старый массив уходят в никуда — переходы внутри SPA не считались вовсе.
    window._tmr.push({ id: VK_PIXEL_ID, type: 'pageView', start: Date.now() })
  })
}
